module.exports = __webpack_public_path__ + "img/preheat_btn_img.9459de5a.png";